import * as React from 'react'
import LandscapeContainer from './containers/LandscapeContainer';
import { AppState } from './types/app';
import BrowserSupport from './components/BrowserSupport';
import TruckSelect from './components/TruckSelect';
import SimulationSelect from './components/SimulationSelect';
import Scene from './components/Scene';
import AsideRight from './components/AsideRight';
import { SimulationsList, ControllBoxStep, CounterStep } from 'types/data';
import { REMOTE_SIMULATION, END_DIALOG } from 'constants/sumilationConstants';
import FreestyleState from 'types/freestyle.types';
import FreestyleAsideRight from 'components/AsideRight/freestyle';

interface AppProps {
  loadData: Function,
  setTruck: Function,
  setViewerApi: Function,
  goToNextSimulation: Function,
  setSimulationSelect: Function,
  setActiveSimulation: Function,
  posibleSimulationTypes?: string[],
  truckSimulations?: SimulationsList,
  setPositionReady: Function,
  setActiveSimulationType: Function,
  setActiveSimulationStep: Function,
  setSimulationSidePanelActive: Function,
  setNextSimulationStep: Function,
  endActiveSimulation: Function,
  showLevers: Boolean,
  restartSimulation: Function,
  setAVSP: Function,
  setContentOpened: Function,
  boxActiveStep?: ControllBoxStep,
  currentCounterStep?: CounterStep,
  freestyle: FreestyleState
}

export default (props: AppProps & AppState) => {
  const { 
    loadData,
    currentCounterStep,
    webglError, 
    data, 
    activeSimulation, 
    setActiveSimulation, 
    setTruck, 
    truck, 
    simulationSidePanelActive,
    setViewerApi, 
    viewerApi, 
    simulationSelectActive, 
    setSimulationSelect,
    posibleSimulationTypes,
    setActiveSimulationStep,
    setActiveSimulationType,
    setAVSP,
    activeSimulationType,
    goToNextSimulation,
    setSimulationSidePanelActive,
    activeSimulationStep,
    afterLeverAnimationProgress,
    truckSimulations,
    activeDialogType,
    setPositionReady,
    positionReady,
    endActiveSimulation,
    lastActiveSimulation,
    showLevers,
    freestyle,
    restartSimulation,
    restartKey,
    setContentOpened, 
    setNextSimulationStep,
    contentOpened,
    boxActiveStep
  } = props;
  const isRemote = activeSimulationType === REMOTE_SIMULATION
  const isDone = activeDialogType === END_DIALOG
  
  React.useEffect(() => {
    !webglError && loadData();
  }, [loadData, webglError])

  React.useEffect(() => {
    posibleSimulationTypes && !activeSimulationType && setActiveSimulationType(posibleSimulationTypes![0])
  }, [posibleSimulationTypes, activeSimulationType, setActiveSimulationType])

  const simulations = data && truck &&
    data.simulations.find(item => item.truck === truck.name)!.list

  React.useEffect(() => {
    if(truckSimulations) {
      viewerApi!.setSimulations(truckSimulations.list)
    }
  }, [truckSimulations, viewerApi])
  
  React.useEffect(() => {
    if (positionReady && isRemote) {
      viewerApi!.RemoteControler.toggle(isRemote)
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [positionReady])
  
  React.useEffect(() => {
    if(activeSimulationType && activeSimulation) {     
      if(!isRemote) {
        viewerApi!.RemoteControler.toggle(isRemote)      
      } 
      if(activeSimulation.additionalCamPos && !isRemote) {  
        if(positionReady) {
          viewerApi!.toggleSimulationTypePosition(activeSimulationType, activeSimulation.additionalCamPos)
            .then(() => {
              setPositionReady(true)
              viewerApi!.isControlBox = true
              viewerApi!.ControlBox.initBox(activeSimulation.controlBox!, boxActiveStep!)
              setSimulationSidePanelActive(true)
            })
        }

      } else {
        if(positionReady) {
          if(activeSimulation.additionalCamPos) {
            setPositionReady(false)
            viewerApi!.setDirectCamPos(activeSimulation.campos.REMOTE_SIMULATION, 0)
          } else {
            viewerApi!.toggleSimulationTypePosition(activeSimulationType)
          }
        }
        // viewerApi!.resetControlBox()
        
        if(!activeSimulation.counterSteps) viewerApi!.RemoteControler.setActiveLights(activeSimulation!.remote.lights)
        if(activeSimulation.secondaryWait) {
          viewerApi!.RemoteControler.blockSecondary = true
          viewerApi!.RemoteControler.onFirstButtonClick = (dir) => {
            if(dir) viewerApi!.RemoteControler.blockSecondary = false
          }
        } else {
          viewerApi!.RemoteControler.blockSecondary = false
        }
      }
        
      if(activeSimulation.remote.greenButton) {
        if(!activeSimulation.counterSteps && activeSimulation.remote.greenButton) {
          viewerApi!.RemoteControler.onFirstGreenButtonClick = () => {
            setActiveSimulationStep(1)
          }
        }
      }
      if(positionReady) {
        if(activeSimulation.counter && activeSimulation.counter.type === 'engine') {
          viewerApi!.Simulations!.getSimById(activeSimulation.id).animationForwards(true)
        }
      }
      viewerApi!.LeversControler.initSim(activeSimulation!.manual)

     
    } else {
      if(!activeSimulation && viewerApi && viewerApi!.Simulations) {
        viewerApi!.resetSimulations()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSimulationType, viewerApi, isRemote, activeSimulation, restartKey])


  
  
  
  return (
    <div>
      <LandscapeContainer/>
      {
      webglError ?
        <BrowserSupport/>
        :
          data ?  
            <>
              <div>
                <Scene
                  boxButtonPressed={setNextSimulationStep}
                  setContentOpened={setContentOpened}
                  setPositionReady={setPositionReady}
                  activeSimulation={activeSimulation}
                  setNextSimulationStep={setNextSimulationStep}
                  currentCounterStep={currentCounterStep}
                  setViewerApi={setViewerApi}
                  freestyle={freestyle}
                  setAVSP={setAVSP}
                  isDone={isDone}
                  afterLeverAnimationProgress={afterLeverAnimationProgress}
                  viewerApi={viewerApi}
                  positionReady={positionReady}
                  simulationSelectActive={simulationSelectActive}
                  setSimulationSelect={setSimulationSelect}     
                  isRemote={isRemote}
                  showButton={simulationSelectActive}
                  showLevers={showLevers}
                  endActiveSimulation={endActiveSimulation}
                  setSimulationSidePanelActive={setSimulationSidePanelActive}
                  isSimulationProgress={Boolean(activeSimulation)}
                  boxActiveStep={boxActiveStep}
                />
                <TruckSelect 
                  viewerApi={viewerApi}
                  setTruck={setTruck} 
                  trucks={data.trucks} 
                  selectedTruck={truck!}
                />
                {
                  truck && simulationSelectActive &&
                    <SimulationSelect 
                      lastActiveSimulation={lastActiveSimulation}
                      simActive={Boolean(activeSimulation)}
                      simulations={simulations!} 
                      setSimulationSelect={setSimulationSelect} 
                      viewerApi={viewerApi!}
                      setActiveSimulation={setActiveSimulation}
                    />
                }
                {
                  activeSimulation && simulationSidePanelActive && activeSimulationType &&
                    <AsideRight 
                      activeSimulation={activeSimulation}
                      contentOpened={contentOpened}
                      setContentOpened={setContentOpened}
                      restartSimulation={restartSimulation}
                      positionReady={positionReady}
                      goToNextSimulation={goToNextSimulation}
                      blockToggler={!positionReady || afterLeverAnimationProgress}
                      setSimulationType={setActiveSimulationType}
                      unmount={() => setActiveSimulation(undefined)}
                      setActiveStep={setActiveSimulationStep}
                      openSimulationSelect={() => setSimulationSelect(true)}
                      viewerApi={viewerApi!}
                      afterLeverAnimationProgress={afterLeverAnimationProgress}
                      simulation={activeSimulation}
                      activeSimulationType={activeSimulationType!}
                      posibleSimulationTypes={posibleSimulationTypes!}
                      activeDialogType={activeDialogType}
                      activeStep={activeSimulationStep}
                      tip={data.tips.find(item => item.name === 'controls')!}
                    /> 
                }
                <FreestyleAsideRight/>
              </div>
            </>
            :
            null
      }
    </div>
  );
};
